import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { fetchCustomers } from '../../actions/customers_actions';
import { fetchCustomersWithFavorites } from '../../actions/favoriteList_actions';
import { fetchInventories } from '../../actions/inventories_actions';
import { fetchFavorites } from '../../actions/favorites_actions';
import { fetchPreviousOrders } from '../../actions/previousOrders_actions';
import { fetchPromotions } from '../../actions/promotions_actions';
import { createSalesOrder, editSalesOrder, fetchSalesOrderDetail } from '../../actions/sales_actions';
import { createWholesale } from '../../actions/wholesale_actions';
import WholesaleOrderForm from '../../components/Sales/wholesaleOrderForm';

const validate = values => {
    const errors = {}
    if (!values.Name) {
        errors.Name = 'Required'
    }
    if (!values.SalesOrderNum) {
        errors.SalesOrderNum = 'Required'
    }
    if (!values.Description) {
        errors.Description = 'Required'
    }
    return errors
}

let wholesaleOrderForm = reduxForm({
    form: 'wholesaleOrderForm',
    validate
})(WholesaleOrderForm);

const selector = formValueSelector('wholesaleOrderForm')

function mapStateToProps(state) {
    const inventoryIdValue = selector(state, 'Inventory_id');
    const quantityValue = selector(state, 'Quantity');
    const description = selector(state, 'Description');
    const available = selector(state, 'Available');
    const inPurchase = selector(state, 'InPurchase');
    const preSale = selector(state, 'PreSale');
    const salePrice = selector(state, 'SalePrice');
    const refPurchasePrice = selector(state, 'RefPurchasePrice');
    const unitPrice = selector(state, 'UnitPrice');
    const customerChosen = selector(state, 'Customer_id');
    const salesNum = selector(state, 'SalesNum');
    const documentDate = selector(state, 'DocumentDate');
    const sales = selector(state, 'Sales');
    const orderDate = selector(state, 'WholesaleOrderDate');
    const dispatchDate = selector(state, 'DispatchDate');

    return {
        inventoryIdValue,
        quantityValue,
        available,
        inPurchase,
        preSale,
        salePrice,
        refPurchasePrice,
        unitPrice,
        customerChosen,
        description,
        salesNum,
        documentDate,
        sales,
        orderDate,
        dispatchDate,

        currentSalesOrder: state.salesOrders.currentSalesOrder,
        currentSalesOrderDetail: state.salesOrders.currentSalesOrderDetail,
        detailIsLoading: state.salesOrders.detailIsLoading,
        detailError: state.salesOrders.detailError,
        initialValues: state.salesOrders.currentSalesOrderDetail,

        customers: state.customers.all,
        customersIsLoading: state.customers.isLoading,
        customersError: state.customers.error,

        isCreating: state.salesOrders.isCreating,
        createError: state.salesOrders.createError,
        created: state.salesOrders.created,
        isEditing: state.salesOrders.isEditing,
        editError: state.salesOrders.editError,
        edited: state.salesOrders.edited,

        inventories: state.inventories.all,
        inventoriesIsLoading: state.inventories.isLoading,
        inventoriesError: state.inventories.error,

        favorites: state.favorites.all,
        favoritesIsLoading: state.favorites.isLoading,
        favoritesError: state.favorites.error,
        currentFavorites: state.favorites.currentFavorites,

        customersWithFavorites: state.customerFavorites.customersWithFavorites,

        previousOrders: state.previousOrders.all,
        previousOrdersIsLoading: state.previousOrders.isLoading,
        previousOrdersError: state.previousOrders.error,
        currentPreviousOrders: state.previousOrders.currentPreviousOrders,

        promotions: state.promotions.all,
        promotionsIsLoading: state.promotions.isLoading,
        promotionsError: state.promotions.error,
        currentPromotions: state.promotions.currentPromotions,
        userPermissions: state.auth.userPermissions
    }
}

export default connect(mapStateToProps, { fetchCustomersWithFavorites, fetchPromotions, fetchPreviousOrders, fetchFavorites, fetchInventories, fetchCustomers, createSalesOrder, editSalesOrder, fetchSalesOrderDetail, createWholesale })(wholesaleOrderForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/wholesaleOrderForm.jsx